import React from 'react';
import SarasPopup from '../../../library/container/popup/SarasPopup';

const BRAND_COLOR_1 = '#FF4081';

const formatDate = (value) => {
    if (!value) return '';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    return date.toLocaleString();
};

const isNewNotification = (message, lastSeenOn) => {
    if (!lastSeenOn || !message?.createdOn) return false;

    const createdOn = new Date(message.createdOn);
    const lastSeen = new Date(lastSeenOn);

    if (Number.isNaN(createdOn.getTime()) || Number.isNaN(lastSeen.getTime())) return false;

    return createdOn > lastSeen;
};

const UserMessageList = (props) => {
    const { anchorRef, open, onClose, messages, lastSeenOn, onOpenMessage } = props;

    const onMessageClick = (event, message) => {
        event.preventDefault();
        event.stopPropagation();

        onOpenMessage(message);
    };

    return (
        <SarasPopup
            anchorRef={anchorRef}
            open={open}
            onClose={onClose}
            paperStyle={{ width: '420px', maxWidth: '92vw', borderRadius: '10px', overflow: 'hidden' }}
        >
            <div style={{ background: '#fff' }}>
                <div style={{ padding: '18px 20px 14px', borderBottom: '1px solid #e8ecf4', fontSize: '1.6rem', fontWeight: 700 }}>
                    Notifications
                </div>
                <div style={{ maxHeight: '520px', overflowY: 'auto' }}>
                    {messages.map((message, index) => {
                        const nextMessage = messages[index + 1];
                        const showDivider =
                            isNewNotification(message, lastSeenOn) &&
                            (!nextMessage || !isNewNotification(nextMessage, lastSeenOn));

                        return (
                            <React.Fragment key={message.id}>
                                <div
                                    onClick={(event) => onMessageClick(event, message)}
                                    style={{ padding: '16px 20px', borderBottom: '1px solid #eef2f7', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', gap: '12px', background: '#fff' }}
                                >
                                    <div style={{ width: '10px', height: '10px', marginTop: '7px', borderRadius: '50%', background: message.isLiveRead ? '#cfd6e2' : BRAND_COLOR_1, flexShrink: 0 }} />
                                    <div style={{ minWidth: 0, flex: 1 }}>
                                        <div style={{ fontSize: '1rem', fontWeight: 700, color: '#222', lineHeight: 1.45, marginBottom: '4px' }}>
                                            {message.title || 'Notification'}
                                        </div>
                                        <div style={{ fontSize: '0.83rem', color: '#6b7280', lineHeight: 1.4 }}>
                                            {formatDate(message.createdOn)}
                                        </div>
                                    </div>
                                </div>
                                {showDivider && (
                                    <div style={{ padding: '10px 20px', background: '#fff' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{ flex: 1, height: '1px', background: '#e3e8f2' }} />
                                            <div style={{ fontSize: '0.78rem', fontWeight: 700, color: BRAND_COLOR_1, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>
                                                New notifications
                                            </div>
                                            <div style={{ flex: 1, height: '1px', background: '#e3e8f2' }} />
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    })}
                    {messages.length === 0 && (
                        <div style={{ padding: '24px 20px', color: '#6b7280', fontSize: '0.95rem' }}>
                            No notifications
                        </div>
                    )}
                </div>
            </div>
        </SarasPopup>
    );
};

export default UserMessageList;
